<template>
  <div>
    <lazy-hydrate never>
      <zg-hero
        :title="pageContent.title"
        :page-type="PAGE_TYPES.contentPage"
        :breadcrumbs="breadcrumbs"
      >
        <template
          v-if="pageContent.subTitle"
          #sub-title
        >
          <rich-text :body="pageContent.subTitle" />
        </template>
      </zg-hero>
    </lazy-hydrate>

    <lazy-hydrate
      if="pageContent.partners"
      never
    >
      <zg-logo-card-section :items="pageContent.partners.items" />
    </lazy-hydrate>
  </div>
</template>

<script>
import { ZgLogoCardSection } from '@zc/components/sections'

import { ZgHero } from '@zc/components/ZgHero'
import LazyHydrate from 'vue-lazy-hydration'
import RichText from '../components/RichText.vue'
import { PAGE_TYPES } from '../utils/constants/content'

export default {
  name: 'PartnerListPage',
  components: {
    LazyHydrate,
    RichText,
    ZgHero,
    ZgLogoCardSection
  },
  props: {
    page: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    PAGE_TYPES
  }),
  computed: {
    breadcrumbs () {
      return this.page.breadcrumbs || []
    },
    pageContent () {
      return this.page.content || {}
    }
  }
}
</script>
